module.exports = __webpack_public_path__ + "media/images/admin_trash-2d5491f7546684d01d815db6a15c8f2a.svg";